import React from "react";
import './ExamView.scss';
import examImage from '../../../assest/images/card-image/ItemAvatar06.png';
import ExamViewState, { ExamViewProps } from "./ExamView.models";
import CommingSoonModal from "../../shared/comming-soon-modal/CommingSoonModal";
import ExamResultService from "../../../services/exam/ExamResultService";
import NotifyContext from "../../../contexts/NotifyContext";
import moment from 'jalali-moment';
import { NavLink } from "react-router-dom";

export default class ExamView extends React.PureComponent<ExamViewProps, ExamViewState> {
    static contextType = NotifyContext
    examResultService: ExamResultService;
    constructor(props: any) {
        super(props);
        this.examResultService = new ExamResultService();
        this.state = {
            exam: {
            },
            startExam: {},
            showModal: false,
            showExamTimeViewModal: false
        }
    }
    componentDidMount() {
        let self = this;
        self.setState({ exam: self.props.exam })
    }
    componentDidUpdate() {
        let self = this;

        self.setState({ exam: self.props.exam })
    }

    // startExam(examId?: number) {
    //     let self = this;

    //     // eslint-disable-next-line no-restricted-globals
    //     let confirmed = confirm('آیا از شرکت در این آزمون مطمئن هستید؟');
    //     if (confirmed) {
    //         self.state.startExam.studentExamId = examId;

    //         self.examResultService.startExam(self.state.startExam).then(function (response) {
    //             if (response && response.status === 200) {
    //                 window.location.href = `/Exam?examId=${examId}&examResultId=${response.data.examId}`;
    //             }
    //             else if (response && response.data.message !== undefined && response.data.message !== null) {
    //                 self.context.showNotify({ badge: "danger", title: "نا موفق", description: response.data.message });
    //             }
    //             else if (self.state.exam.examDateTimeFrom && self.state.exam.examDateTimeTo && self.state.exam.examTime)
    //                 self.props.openModal(self.state.exam.id as number, self.state.exam.examDateTimeFrom, self.state.exam.examDateTimeTo, self.state.exam.examTime);
    //             else
    //                 self.context.showNotify({ badge: "danger", title: "نا موفق", description: "شما مجوز ورود به آزمون را ندارید" })

    //         })
    //     }
    // }

    closeModal = () => {
        this.setState({ showModal: false });
    }

    render(): React.ReactNode {
        let exam = this.state.exam;
        let joinExamButton;

        if (exam.id != null) {
            if (exam.canJoin)
                joinExamButton = (<div className="col-12 tk-padding-bottom">
                    <NavLink to={`/ExamIntroduction?examId=${exam.id}`} className={"gift-list-area"}>
                        <button className="btn btn-success tk-full-width">شرکت در آزمون</button>
                    </NavLink>
                </div>)
            else
                joinExamButton = (<div className="col-12 tk-padding-bottom">
                    <button className="btn btn-success tk-full-width" disabled>{exam.examDateTime !== null && exam.examDateTime !== undefined && exam.examDateTime !== "" ? exam.examDateTime : exam.examDateTimeFrom + " تا " + exam.examDateTimeTo}</button>
                </div>)
        }
        else {
            joinExamButton = "";
        }

        return <>
            <div className="exam-view-area col-12" key={exam.id}>
                <div className={`tk-card ${exam.alreadyJoined? "bg-grey" : ""}`}>
                    <div className="card-icon">
                        <img src={examImage} alt="exam icon" />
                    </div>
                    <div className="card-title">
                        <label>
                            {exam.title}
                        </label>
                    </div>
                    <div className="col-12 user-info">
                        <div className="tk-inline">
                            <div className="col-6 notspace">
                                <label>رشته</label>
                            </div>
                            <div className="col-6 notspace info">
                                <label>{exam.studentFieldTitle}</label>
                            </div>
                        </div>
                        <div className="tk-inline">
                            <div className="col-6 notspace">
                                <label>پایه</label>
                            </div>
                            <div className="col-6 notspace info">
                                <label>{exam.studentBaseTitles}</label>
                            </div>
                        </div>
                        {/* <div className="tk-inline">
                            <div className="col-6 notspace">
                                <label>میزان دشواری </label>
                            </div>
                            <div className="col-6 notspace info">
                                <label>{exam.examLevelType}</label>
                            </div>
                        </div> */}
                        <div className="tk-inline">
                            <div className="col-6 notspace">
                                <label> تعداد سوالات</label>
                            </div>
                            <div className="col-6 notspace info">
                                <label>{exam.totalQuestions}</label>
                            </div>
                        </div>
                        <div className="tk-inline">
                            <div className="col-6 notspace">
                                <label> مدت </label>
                            </div>
                            <div className="col-6 notspace info">
                                <label>{exam.examDuration} دقیقه</label>
                            </div>
                        </div>
                        <div className="tk-inline">
                            <div className="col-6 notspace">
                                <label> ساعت برگزاری </label>
                            </div>
                            <div className="col-6 notspace info">
                                <label>{exam.examTime}</label>
                            </div>
                        </div>
                        {
                            exam.examDateTimeFrom &&
                            <div className="tk-inline">
                                <div className="col-4 notspace">
                                    <label> تاریخ برگزاری </label>
                                </div>
                                <div className="col-8 notspace info">
                                    <label>{exam.examDateTimeTo && moment(exam.examDateTimeTo).locale('fa').format('YYYY/MM/DD')}</label>
                                    <label style={{ padding: '0 2px' }}> {!exam.examDateTimeTo? "از" : "تا"}  </label>
                                    <label>{exam.examDateTimeFrom && moment(exam.examDateTimeFrom, 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD')}</label>
                                </div>
                            </div>
                        }
                    </div>
                    {joinExamButton}
                </div>
            </div>
            <CommingSoonModal closeModal={this.closeModal} showModal={this.state.showModal} />
        </>;
    }
}

